import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Grid, Typography, Button as MUIButton } from '@material-ui/core';
import { Row } from '../../Resources';

import ActivitiesRegistrationHeader from 'components/ActivitiesRegistrationDetails/ActivitiesRegistrationHeader';

const translateDayOfWeek = dayOfWeek => {
  switch(dayOfWeek?.toLowerCase()) {
    case 'monday':
      return 'Segunda-feira';
    case 'tuesday':
      return 'Terça-feira';
    case 'wednesday':
      return 'Quarta-feira';
    case 'thursday':
      return 'Quinta-feira';
    case 'friday':
      return 'Sexta-feira';
    case 'saturday':
      return 'Sábado';
    case 'sunday':
      return 'Domingo';
    default:
      return dayOfWeek || '--';
  }
}

const formatTime = time => {
  if(!time) {
    return '--';
  }

  return String(time).slice(0, 5);
}

const formatDayOfMonth = day => {
  if(!day) {
    return '--';
  }

  const parsedDay = moment(day, 'YYYY-MM-DD');

  if(!parsedDay.isValid()) {
    return day;
  }

  return parsedDay.format('DD/MM/YYYY');
}

const getWeeklyPeriods = weeklySettings => {
  if(Array.isArray(weeklySettings)) {
    return weeklySettings.map(item => ({
      day: translateDayOfWeek(item?.dayOfWeek || item?.day),
      startTime: item?.startTime,
      endTime: item?.endTime
    }));
  }

  if(weeklySettings && typeof weeklySettings == 'object') {
    return Object.entries(weeklySettings).flatMap(([day, ranges]) => {
      const periods = Array.isArray(ranges) && ranges.length > 0 ? ranges : [{}];

      return periods.map(period => ({
        day: translateDayOfWeek(day),
        startTime: period?.startTime,
        endTime: period?.endTime
      }));
    });
  }

  return [];
}

const getDayOfMonthPeriods = dayOfMonthSettings => {
  if(Array.isArray(dayOfMonthSettings)) {
    return dayOfMonthSettings.map(item => ({
      day: item?.dayOfMonth || item?.day,
      startTime: item?.startTime,
      endTime: item?.endTime,
      deletedAt: item?.deletedAt
    }));
  }

  if(dayOfMonthSettings && typeof dayOfMonthSettings == 'object') {
    return Object.entries(dayOfMonthSettings).flatMap(([day, ranges]) => {
      const periods = Array.isArray(ranges) && ranges.length > 0 ? ranges : [{}];

      return periods.map(period => ({
        day,
        startTime: period?.startTime,
        endTime: period?.endTime
      }));
    });
  }

  return [];
}

const EMAIL_CONFIG_FIELDS = [
  { name: 'confirmation', label: 'Email de confirmação' },
  { name: 'cancelling', label: 'Email de cancelamento' },
  { name: 'd2', label: 'Lembrete dois dias antes' },
  { name: 'd1', label: 'Lembrete um dia antes' },
  { name: 'd0', label: 'Lembrete no dia' }
];

function ConfigurationRegister({ register }) {
  const keys = Object.keys(register || {});
  const weeklyPeriods = keys.includes('weeklySettings') ? getWeeklyPeriods(register?.weeklySettings) : [];
  const dayOfMonthPeriods = keys.includes('dayOfMonthSettings') ? getDayOfMonthPeriods(register?.dayOfMonthSettings) : [];

  return(
    <Grid style={{ backgroundColor: '#FCFCFC', border: '1px solid #E4E7EA', padding: 8 }}>
      {keys.includes('mandatoryClient') && (
        <Row>
          <Typography color='primary'>Cliente obrigatório na criação de agendamento</Typography>
          <Typography color='textSecondary'>{+register?.mandatoryClient == 1 ? 'Ativado' : 'Desativado'}</Typography>
        </Row>
      )}
      {EMAIL_CONFIG_FIELDS.map(field => (
        keys.includes(field.name) && (
          <Row key={field.name}>
            <Typography color='primary'>{field.label}</Typography>
            <Typography color='textSecondary'>{+register?.[field.name] == 1 ? 'Sim' : 'Não'}</Typography>
          </Row>
        )
      ))}
      {(weeklyPeriods?.length > 0) && (
        <>
          {keys.includes('weeklySettings') && (
            <>
              <div style={{ marginTop: 15 }} />
              <Row>
                <Typography color='primary'>
                  <b>Disponibilidade geral</b>
                </Typography>
              </Row>
              {weeklyPeriods.map((item, index) => (
                <React.Fragment key={`weekly-${item?.day}-${item?.startTime}-${index}`}>
                  <Row marginTop={8}>
                    <Typography color='primary'>Dia</Typography>
                    <Typography color='textSecondary'>{item?.day}</Typography>
                  </Row>
                  <Row>
                    <Typography color='primary'>Hora início</Typography>
                    <Typography color='textSecondary'>{formatTime(item?.startTime)}</Typography>
                  </Row>
                  <Row>
                    <Typography color='primary'>Hora fim</Typography>
                    <Typography color='textSecondary'>{formatTime(item?.endTime)}</Typography>
                  </Row>
                </React.Fragment>
              ))}
            </>
          )}
        </>
      )}
      {(dayOfMonthPeriods?.length > 0) && (
        <>
          {keys.includes('dayOfMonthSettings') && (
            <>
              <div style={{ marginTop: 15 }} />
              <Row>
                <Typography color='primary'>
                  <b>Disponibilidade ajustada</b>
                </Typography>
              </Row>
              {dayOfMonthPeriods.map((item, index) => (
                <React.Fragment key={`month-${item?.day}-${item?.startTime}-${index}`}>
                  {!!item?.deletedAt ? (
                    <>
                      <Row marginTop={8}>
                        <Typography color='primary'>Dia</Typography>
                        <Typography color='textSecondary'>{formatDayOfMonth(item?.day)}</Typography>
                      </Row>
                      <Row marginTop={8}>
                        <Typography></Typography>
                        <Typography color='textSecondary'>Indisponível</Typography>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row marginTop={8}>
                        <Typography color='primary'>Dia</Typography>
                        <Typography color='textSecondary'>{formatDayOfMonth(item?.day)}</Typography>
                      </Row>
                      <Row>
                        <Typography color='primary'>Hora início</Typography>
                        <Typography color='textSecondary'>{formatTime(item?.startTime)}</Typography>
                      </Row>
                      <Row>
                        <Typography color='primary'>Hora fim</Typography>
                        <Typography color='textSecondary'>{formatTime(item?.endTime)}</Typography>
                      </Row>
                    </>
                  )}
                </React.Fragment>
              ))}
            </>
          )}
        </>
      )}
    </Grid>
  );
}

export default function SchedulingConfiguration({ activityData, lastRegister, newRegister }) {
  const IS_CURRENT = 'current';
  const IS_PREVIOUS = 'previous';

  const [selectedConfig, setSelectedConfig] = useState(IS_CURRENT);

  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader
          activityData={activityData}
        />
        <Grid container style={{ marginTop: 20 }}>
          <Grid md={6} style={{ backgroundColor: (selectedConfig == IS_CURRENT) ? 'rgba(44, 169, 214, 0.24)' : '#E4E7EA', borderBottom: (selectedConfig == IS_CURRENT) ? '2px solid #022A5C' : '' }}>
            <MUIButton
              style={{ width: '100%', textTransform: 'capitalize', padding: 15 }}
              onClick={() => setSelectedConfig(IS_CURRENT)}
            >
              {(selectedConfig == IS_CURRENT) ? (
                <Typography color='primary'>
                  <b>Configuração Atual</b>
                </Typography>
              ) : (
                <Typography color='textSecondary'>Configuração Atual</Typography>
              )}
            </MUIButton>
          </Grid>
          <Grid md={6} style={{ backgroundColor: (selectedConfig == IS_PREVIOUS) ? 'rgba(44, 169, 214, 0.24)' : '#E4E7EA', borderBottom: (selectedConfig == IS_PREVIOUS) ? '2px solid #022A5C' : '' }}>
            <MUIButton
              style={{ width: '100%', textTransform: 'capitalize', padding: 15 }}
              onClick={() => setSelectedConfig(IS_PREVIOUS)}
            >
              {(selectedConfig == IS_PREVIOUS) ? (
                <Typography color='primary'>
                  <b>Configuração Anterior</b>
                </Typography>
              ) : (
                <Typography color='textSecondary'>Configuração Anterior</Typography>
              )}
            </MUIButton>
          </Grid>
        </Grid>
        <Grid container>
          {(selectedConfig == IS_CURRENT) && (
            <Grid xs={12}>
              <ConfigurationRegister register={newRegister} />
            </Grid>
          )}
          {(selectedConfig == IS_PREVIOUS) && (
            <Grid xs={12}>
              <ConfigurationRegister register={lastRegister} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

SchedulingConfiguration.propTypes = {
  lastRegister: PropTypes.object.isRequired,
  newRegister: PropTypes.object.isRequired,
  activityData: PropTypes.object.isRequired
};

ConfigurationRegister.propTypes = {
  register: PropTypes.object
};